<template>
  <div class="item-wrapper">
    <div class="bread-crumbs" style="height: 22px">
      <!-- <router-link to="/">首页</router-link>
      <template v-if="navs.length">
        <router-link v-for="nav in navs" :key="`nav-${nav.id}`" :to="`/store/all/line-up/onitsukater/${nav.path}`">{{nav.name}}</router-link>
      </template> -->
    </div>
    <div class="item-container" v-if="info">
      <!-- 商品图片 & 商品规格 -->
      <div class="pdp-top">
        <ViewItemInfo :source="info" scope="detail" :isGwMdEnablePoint="isGwMdEnablePoint" @confirm="addToCart"
          @checkout="toBuyNow" @notify="showNotifyDialog" @change="onViewInfoChange" />
      </div>
      <!-- 商品详情 & 相关推荐 & 最近浏览 -->
      <div class="pdp-btm">
        <Recommend :uid="info.id" />
        <div class="item-info" v-if="info.detail && info.detail != '#N/A' && info.detail != '0'">
          <div class="item-details">
            <h3 class="item-section-header">商品详情</h3>
            <div class="item-details-text">{{ info.detail }}</div>
          </div>
          <div class="item-feature" style="display: none">
            <h3 class="item-section-header">Product Features</h3>
          </div>
        </div>
        <RecentlyViewed :uid="info.id" />
      </div>
    </div>
    <!-- 到货通知弹窗 -->
    <div class="dialog notify-dialog" v-if="notifyItem">
      <div class="mask"></div>
      <div class="dialog">
        <div class="dialog-container">
          <div class="dialog-header">
            <button class="dialog-close" @click="hideNotifyDialog">
              <span class="close-icon"></span>
            </button>
          </div>
          <div class="dialog-body">
            <ItemNotify :source="notifyItem" @confirm="sendNotify" />
          </div>
        </div>
      </div>
    </div>
    <!-- 加购成功弹窗（共用组件） -->
    <CartSuccessDialog :info="cartInfo" :headerHeight="headerHeight" @close="closeCartDialog(0)"
      @checkout="toCheckout" @cart="toCart" :isGwMdEnablePoint="isGwMdEnablePoint"/>
    <!-- 登录弹窗 -->
    <div class="dialog login-dialog" v-if="showLogin">
      <div class="mask"></div>
      <div class="dialog-container">
        <div class="dialog-header">
          <i class="iconfont dialog-close" @click="hideLoginDialog">&#xe612;</i>
        </div>
        <div class="dialog-body">
          <Login :returnUrl="returnUrl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Recommend from "@/components/Recommend.vue";
import RecentlyViewed from "@/components/RecentlyViewed.vue";
import ViewItemInfo from "@/components/ViewItemInfo.vue";
import ItemNotify from "@/components/ItemNotify.vue";
import Login from "@/components/Login.vue";
import CartSuccessDialog from "@/components/CartSuccessDialog.vue";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
export default {
  name: "Detail",
  components: { Recommend, RecentlyViewed, ViewItemInfo, ItemNotify, Login, CartSuccessDialog },
  data() {
    return {
      // 功能基础数据
      info: null,
      // 弹窗数据
      notifyItem: null, // 到货通知 - 状态
      cartInfo: null, // 加入购物车成功
      returnUrl: "/checkout", // 登录后的跳转地址
      showLogin: false, // 是否显示登录弹窗
      pendingBuyNow: null, // 未登录点立即购买暂存的直购参数，登录成功后自动重放
      headerHeight: 0, // 添加 header 高度数据
      skipNextLoad: false // 老路由 URL 归一化 replace 导致的路由变化无需重新加载

    };
  },
  created() {
    const { isLegacy, id, color, sku } = this.parseSpu();
    // 按来源路由校验: detail 老路由需截取出 id/color; product 新路由 sku 本身可能含 "-", 仅校验非空
    const valid = isLegacy ? !!(id && color) : !!sku;
    if (!valid) {
      console.warn(`invalid sku param: ${sku || id}`);
      this.$router.replace({ name: "Home" });
    } else {
      this.loadSource();
    }
  },
  mounted() {
    this.updateHeaderHeight();
    window.addEventListener('scroll', this.updateHeaderHeight);
    window.addEventListener('resize', this.updateHeaderHeight);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.updateHeaderHeight);
    window.removeEventListener('resize', this.updateHeaderHeight);
  },
  methods: {
    updateHeaderHeight() {
      const header = document.querySelector('.header');
      this.headerHeight = header ? header.offsetHeight : 0;
    },
    // 初始路由 path 决定取参方式: 统一返回 {id, color, sku}, 不适用的字段传空串
    // - /detail/:id 老链接入口: 参数为 "id-color", 按第一个 "-" 截取 id/color, 查询后替换为新 /product/ 链接
    // - /product/:seriesSlug/:sku 新链接入口: 直接取 params.sku , sku 本身可能含 "-", 不做截取、不做替换
    parseSpu() {
      // 是否老 URL 以路由元信息为准（与下方 replace 时的判断同一口径），params.id 只负责解析
      const isLegacy = !!this.$route.meta.legacy;
      if (isLegacy) {
        const raw = this.$route.params.id || "";
        const idx = raw.indexOf("-");
        return {
          isLegacy,
          id: idx > -1 ? raw.slice(0, idx) : "",
          color: idx > -1 ? raw.slice(idx + 1) : "",
          sku: ""
        };
      }
      return {
        isLegacy,
        id: "",
        color: "",
        sku: this.$route.params.sku || ""
      };
    },
    //
    loadSource() {
      const { id, color, sku } = this.parseSpu();
      // 统一传 {id, color, sku}: detail 老路由走 id+color, product 新路由走 sku, 其余为空串
      api[types.GET_DETAIL](id, color, sku)
        .then((res) => {
          if (res.data) {
            this.info = res.data;
            const { name = '' } = res.data || {}
            utils.setPageTitle(name)
            // 老路由进来: 用接口返回的 pdp_url(seriesSlug/sku) replace 成新 URL, 缺失时保持老 URL 不替换
            if (this.$route.meta.legacy && res.data.pdp_url) {
              this.skipNextLoad = true;
              this.$router.replace({
                path: `/product/${res.data.pdp_url}`,
                query: this.$route.query
              });
            }
          } else {
            console.warn(res);
            // OWHS-10096 - 【OT】后端返回商品id或color为空时判断
            setTimeout(() => this.$router.replace({ name: "Home" }), 1000)
          }
        })
        .catch((err) => {
          console.error(err);
          // OWHS-10096 - 【OT】后端返回商品id或color为空时判断
          setTimeout(() => this.$router.replace({ name: "Home" }), 1000)
        });
    },
    // 组件内切色已本地换数据并替换路由, 这里仅标记跳过 $route watcher 的重拉
    onViewInfoChange(args) {
      if (args?.type !== "color") return;
      // 路径相同(重复点同色)不会发生导航, 不置标记避免残留
      const path = this.getProductRoutePath(args.value);
      if (path && path !== this.$route.path) {
        this.skipNextLoad = true;
      }
    },
    // 立即购买：登录走直购结算，未登录先登录、成功后自动重放直购
    toBuyNow(args) {
      let { size, quantity, skuStatus } = args;
      // 根据 SKU 状态决定购物袋类型：预售→is_presale，普通→is_buy_now
      const cartType = utils.getCartType(skuStatus === 'PreSales' ? 'presale' : 'buy_now');
      const params = { sku: String(size.sku || size.id), qty: quantity, cartType };
      if (this.isLogin) {
        this.execBuyNow(params);
      } else {
        // 未登录：暂存直购参数并弹登录框（returnUrl 回当前页），登录成功后由 isLogin watcher 自动重放
        this.pendingBuyNow = params;
        this.returnUrl = encodeURIComponent(this.$route.fullPath);
        this.showLoginDialog();
      }
    },
    // 执行直购：BUY_NOW 成功缓存后带 cartType 进结算页
    async execBuyNow(params) {
      try {
        const res = await api[types.BUY_NOW](params);
        if (res?.code == 1) {
          const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
          // URL 带 sku/qty/cartType: 刷新结算页时缓存丢失可重调 BUY_NOW 重建结算数据
          this.$router.push({ path: `/checkout?cartType=${params.cartType}&sku=${params.sku}&qty=${params.qty}&confirmCacheKey=${confirmCacheKey}` });
        } else {
          console.warn(res);
        }
      } catch (err) {
        console.error(err);
      }
    },
    addToCartEnd(args) {
      let { info, color, quantity } = args;
      this.$store.dispatch(types.GET_CART_INFO);
      this.closeCartDialog(3000);
      // TODO: 字段映射
      this.gaTrack4AddToCart({
        id: info.style_number,
        name: info.name,
        price: info.price,
        quantity,
        category: info.category?.name,
        variant: color?.name,
      });
    },
    // 加入购物车
    addToCart(args) {
      let { info, color, size, quantity } = args;
      const params = {
        product: String(info.id),
        product_option: [
          {
            option_id: color?.attribute_id,
            option_value: color?.id,
          },
          {
            option_id: size?.attribute_id,
            option_value: size?.option_id,
          },
        ],
        qty: quantity,
        sku: String(size.sku || size.id),
        is_presale: Number(color?.is_pre_sales) === 1,
      }
      if (this.isLogin) {
        api[types.ADD_TO_CUSTOMER_CART](params)
          .then((res) => {
            if (res?.code == 1) {
              this.cartInfo = res.data.info;
              this.cartInfo.info.cover = this.cartInfo?.info?.images[0];
              this.addToCartEnd(args);
            }
          })
          .catch((err) => {
            console.error(err);
            // this.$message({ message: "网络异常" });
          });
      } else {
        api[types.ADD_TO_CART_GUEST](params)
          .then((res) => {
            if (res?.code == 1) {
              this.cartInfo = res.data.info;
              this.cartInfo.info.cover = this.cartInfo?.info?.images[0];
              this.addToCartEnd(args);
            }
          })
          .catch((err) => {
            console.error(err);
            // this.$message({ message: "网络异常" });
          });
      }
    },
    //
    gaTrack4AddToCart(info) {
      if (info?.id && window.gtag) {
        window.gtag("event", "add_to_cart", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "CNY",
          value: Number(info.price),
          items: [
            {
              item_id: info.id,
              item_name: info.name,
              item_brand: "Onitsuka Tiger",
              item_category: info.category,
              item_variant: info.variant,
              price: Number(info.price),
              quantity: Number(info.quantity),
              currency: "CNY",
            },
          ],
        });
      }
    },
    // 延迟一秒钟关闭加入购物车成功碳层
    closeCartDialog(time) {
      setTimeout(() => {
        this.cartInfo = null;
      }, time);
    },
    // 加入购物车成功 -> 立即结算
    toCheckout() {
      if (this.isLogin) {
        const { size, quantity } = this.cartInfo?.info || {}
        const params = { sku: String(size.sku || size.id), qty: quantity, cartType: 'is_buy_now' }
        api[types.BUY_NOW](params).then(async res => {
          if (res?.code == 1) {
            const confirmCacheKey = await this.$store.dispatch('requestCache/setRequestCache', { params, value: res });
            this.$router.push({ path: `/checkout?confirmCacheKey=${confirmCacheKey}` });
          } else {
            console.warn(res);
          }
        })
      } else {
        this.showLoginDialog();
      }
    },
    // 加入购物车成功 -> 去购物车
    toCart() {
      this.$router.push({ path: "/cart" });
    },
    // 显示到货通知弹窗
    showNotifyDialog(info) {
      this.notifyItem = info;
    },
    hideNotifyDialog() {
      this.notifyItem = null;
    },
    // 显示登录弹窗
    showLoginDialog() {
      this.showLogin = true;
    },
    // 关闭登录弹窗
    hideLoginDialog() {
      this.returnUrl = "/checkout";
      this.showLogin = false;
    },
    // 到货通知设置成功
    sendNotify() {
      this.hideNotifyDialog();
    },
  },
  computed: {
    // 是否允许显示原价（受 gw_md_enable 配置控制）
    isGwMdEnablePoint() {
      return utils.isGwMdEnable(this.$store.state.commonConfig['gw_md_enable'], 'pdp')
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    navs() {
      let ret = [];
      if (this.info) {
        let { gender, category } = this.info;
        ret.push({ id: gender.id, name: gender.name, path: gender.id });
        ret.push({
          id: category.id,
          name: category.name,
          path: `${gender.id}-${category.id}`,
        });
      }
      return ret;
    }
  },
  watch: {
    // 登录成功后关闭登录弹框（Login 组件无事件回调，以登录态变化感知）
    isLogin(val) {
      if (val && this.showLogin) {
        this.hideLoginDialog();
      }
      // 登录成功且有暂存直购参数：自动重放 buyNow 流程
      if (val && this.pendingBuyNow) {
        const params = this.pendingBuyNow;
        this.pendingBuyNow = null;
        this.execBuyNow(params);
      }
    },
    $route() {
      // 老路由 URL 归一化 replace 引起的路由变化, 数据已加载, 跳过
      if (this.skipNextLoad) {
        this.skipNextLoad = false;
        return;
      }
      this.loadSource();
    },
  },
};
</script>

<style lang="scss" scoped>
.item-wrapper {
  background: #efefef;

  .bread-crumbs {
    box-sizing: border-box;
    margin: auto;
    width: calc(100% - 20px);
    max-width: 1200px;
    font-size: calc(0.6875rem * 1.6);
    line-height: 1em;
    padding: 0.5em 0;
    text-align: left;
    color: #4B4F54;

    a {
      font-weight: 400;
      font-size: calc(0.6875rem * 1.6);
      color: #4B4F54;
      letter-spacing: 0.025em;
      overflow: hidden;
      text-decoration: none;
      cursor: pointer;
      margin-right: 4px;

      &::after {
        color: #ccc;
        content: "/";
        margin-left: 0.4em;
        display: inline-block;
      }

      &:last-child::after {
        content: "";
      }

      &:hover {
        font-weight: 400;
        color: #999;
        text-decoration: underline;
      }
    }
  }

  .item-container {
    margin-bottom: 20px;

    .pdp-top {
      box-sizing: border-box;
      margin: auto;
      width: calc(100% - 20px);
      max-width: 1200px;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -ms-flex-wrap: wrap;
      -webkit-flex-wrap: wrap;
      flex-wrap: wrap;

      & ::v-deep .item-wrapper .item-images {
        width: calc(98% - 410px);
      }

      & ::v-deep .item-wrapper .item-detail {
        width: 410px;
      }
    }

    .pdp-btm {
      border-top: 1px solid #b4b5b4;
      margin-top: 30px;
      background: #fff;

      .item-info {
        box-sizing: border-box;
        width: 85%;
        max-width: 1200px;
        padding: 0;
        margin: 0 auto;

        .item-details,
        .item-feature {
          padding: 0 0 30px;
          margin: 0 10px;

          .item-section-header {
            margin: 30px 0;
            text-align: center;
            font-size: 20px;
            font-weight: 400;
            color: #000;
          }

          .item-details-text {
            color: #000;
            font-weight: 400;
            font-size: calc(0.875rem * 1.6);
            line-height: calc(1.3rem * 1.6);
            text-align: left;
          }
        }

        .item-feature {
          ul {
            overflow: auto;
            text-align: left;

            li {
              box-sizing: border-box;
              width: calc(50% - 20px);
              font-weight: 400;
              font-size: calc(0.875rem * 1.6);
              color: #000;
              padding: 0 20px 15px 0;
              margin: 0 0 10px;
              float: left;

              div {
                font-weight: 700;
                font-size: calc(1rem * 1.6);
              }
            }

            &::after {
              clear: both;
            }
          }
        }
      }
    }
  }

  .dialog {
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      // background: url(../assets/imgs/ui-overlay-shadow.png) repeat scroll 50% 50% #000;
      opacity: 0.3;
    }

    .dialog-container {
      box-sizing: border-box;
      position: fixed;
      z-index: 1011;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      min-width: 300px;
      max-width: 95%;
      min-height: 200px;
      border-radius: 4px;

      .dialog-header {
        position: relative;
        text-align: left;

        .dialog-close {
          width: 32px;
          height: 32px;
          position: absolute;
          top: -15px;
          right: -15px;
          z-index: 1;
          padding: 0;
          border: none;
          border-radius: 0;
          margin: 0;
          background-color: transparent;
          font-size: 0;
          cursor: pointer;

          .close-icon {
            background-image: url(../assets/imgs/icons/onitsukatiger-close.svg);
            background-position: 0 0;
            background-repeat: no-repeat;
            height: 32px;
            width: 32px;
            margin: 0;
            padding: 0;
            display: block;
            text-indent: -99999px;
            overflow: hidden;
          }
        }
      }

      .dialog-body {
        display: flex;
        box-sizing: border-box;
      }
    }

    &.notify-dialog {
      .dialog-container {
        width: 834px;
        background-color: #efefef;

        .dialog-header {
          .dialog-title {
            border-bottom: 1px solid #b4b5b4;
            font-weight: 400;
            font-size: calc(1.375rem * 1.6);
            color: #000;
            text-transform: uppercase;
            padding: calc(1.25rem * 1.6) calc(1.25rem * 1.6) calc(0.5rem * 1.6) 0;
            margin: 0 calc(1.25rem * 1.6);
            width: calc(100% - 40px);
            box-sizing: border-box;
          }
        }

        .dialog-body {
          padding: 20px;
        }
      }
    }

    &.login-dialog {
      .dialog-container {
        width: 470px;
        height: 600px;

        .dialog-header {
          height: 40px;

          .dialog-close {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 32px;
            color: #999999;
            cursor: pointer;
          }
        }

        .dialog-body {

          // padding: 0 45px;
          & ::v-deep .login-component {
            width: 100%;

            .title {
              text-align: center;
            }

            .el-form {
              width: 75%;
            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .item-wrapper {
    background: #fff;

    .item-container {
      .pdp-top {
        width: 100%;

        & ::v-deep .item-wrapper .item-extra-mobile {
          padding: 0 10px;
        }

        & ::v-deep .item-wrapper .item-images {
          width: 100%;
        }

        & ::v-deep .item-wrapper .item-detail {
          width: 100%;
        }
      }

      .pdp-btm {
        border-top: none;

        .item-info {
          .item-feature {
            ul {
              li {
                width: 100%;
              }
            }
          }
        }
      }
    }

    .dialog {
      &.notify-dialog {
        .dialog-container {
          position: absolute;
          top: 100px;
          transform: translate(-50%, 0);
          background: #fff;
        }
      }

      .item-detail-brand {
        font-size: 10px !important;
        margin-bottom: 4px !important;
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .item-wrapper {
    .dialog {
      &.notify-dialog {
        .dialog-container {
          top: 50px;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-header {
            .dialog-close {
              top: 10px;
              right: 10px;

              .close-icon {
                background-image: url(../assets/imgs/icons/onitsukatiger-close2.svg);
                background-position: center center;
              }
            }
          }
        }
      }

      &.login-dialog {
        .dialog-container {
          position: fixed;
          top: 0;
          left: 0;
          transform: none;
          // transform: translate(-50%, 0);
          background: #fff;
          width: 100%;
          max-width: 100%;
          border-radius: 0;

          .dialog-body ::v-deep .login-component {
            .el-form {
              width: calc(100% - 40px);
            }
          }
        }
      }
    }
  }
}
</style>
